import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Backdrop, Block, Divider, Overlay, Portal, Tabs } from "reakit";
import { Box, Card, Flex, Heading, Image, Text } from "rebass";
import { TabHeader } from "../../components/Base";
import check from "../../resources/img/icons/Checkbox@1x-black.png";
import chevronRight from "../../resources/img/icons/Chevron_2@1x.png";
import IosArrowBack from "react-ionicons/lib/IosArrowBack";
import { Radio, FormCheckLabel } from "@smooth-ui/core-sc";

const FilterOverlay = styled(Overlay)`
  width: 100%;
  height: 100%;
  padding: 0;
  display: flex; /* [1] */
  flex-wrap: nowrap; /* [1] */
  overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
`;

const HeaderWrapper = styled(Card)`
  position: relative;
  top: 0;
  left: 0;
  width: 100vw;
  max-height: 182px;
`;

const TabsContainer = styled(Box)`
  display: none;
  ${({ show }) =>
    show &&
    `
		display: block;
	`}
`;

const TabList = styled(Box)`
  box-sizing: border-box;
  box-shadow: 0 6px 6px -4px rgba(0, 0, 0, 0.16);
  position: relative;
  z-index: 9999;
  background-color: white;
  top: -6px;
`;

const textProps = {
  ml: 3,
  fontWeight: 600,
};
//
// export const VerticalScroll = styled(Box)`
//   display: flex; /* [1] */
//   flex-wrap: nowrap; /* [1] */
//   overflow-y: auto; /* [1] */
//   -webkit-overflow-scrolling: touch; /* [4] */
//   -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
// `
class Audience extends Component {
  state = {
    audience: [[], [], [], []],
  };

  componentDidMount() {
    const { editPost } = this.props;
    if (editPost === true) {
      this.setState({ audience: this.props.defaultValue });
    }
  }

  handleSelect = (name, index) => {
    const { audience } = this.state;
    const { handleUpdate } = this.props;
    let contains = false;
    for (var i = audience[index].length - 1; i >= 0; i--) {
      if (audience[index][i] === name) {
        audience[index].splice(i, 1);
        contains = true;
        this.setState({ audience });
        // break;       //<-- Uncomment  if only the first term has to be removed
      }
    }

    if (!contains) {
      audience[index].push(name);
      this.setState({ audience });
    }

    handleUpdate(audience);
  };

  render() {
    const { audience } = this.state;
    const {
      dorms,
      radioAudience,
      handleRadioChange,
      audienceFaculty,
      handleAudienceFaculty,
      handleSelectGeneral,
      generalStudent,
      generalFaculty,
    } = this.props;
    return (
      <Overlay.Container>
        {(overlay) => (
          <Block width={"100%"}>
            <Flex onClick={overlay.show} {...overlay}>
              <Box>
                <Text fontWeight={600} ml={3}>
                  Audience
                </Text>
              </Box>
              <Box mr={"auto"} />
              <Box>
                <Image src={chevronRight} />{" "}
              </Box>
            </Flex>
            <Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
            <FilterOverlay use={Portal} {...overlay}>
              <Flex flexDirection={"column"} width={"100%"} p={0}>
                <HeaderWrapper boxShadow={"main"} pt={2} px={2} width={1}>
                  <Box ml={0} mt={2} height={"30px"} width={"30px"}>
                    <IosArrowBack fontSize={"30px"} onClick={overlay.hide} />
                  </Box>
                  <Heading mx={"8px"}>
                    Audience
                    <Flex
                      my={2}
                      alignItems={"center"}
                      justifyContent={"flex-start"}
                    >
                      <Flex mr={3}>
                        <Radio
                          size="sm"
                          id="studentRadio"
                          value="student"
                          onChange={handleRadioChange}
                          checked={radioAudience === "student"}
                        />
                        <FormCheckLabel
                          fontSize={"16px"}
                          color={"metaText"}
                          htmlFor="studentRadio"
                        >
                          Student
                        </FormCheckLabel>
                      </Flex>
                      <Flex>
                        <Radio
                          size="sm"
                          id="facultyRadio"
                          value="faculty"
                          onChange={handleRadioChange}
                          checked={radioAudience === "faculty"}
                        />
                        <FormCheckLabel
                          fontSize={"16px"}
                          color={"metaText"}
                          htmlFor="facultyRadio"
                        >
                          Faculty
                        </FormCheckLabel>
                      </Flex>
                    </Flex>
                  </Heading>
                </HeaderWrapper>
                <TabsContainer show={radioAudience === "student"}>
                  <Tabs.Container width={"100%"} margin={0} padding={0}>
                    {(tabs) => (
                      <Box>
                        <TabList>
                          <Tabs width={"100%"} margin={0} padding={0}>
                            <Tabs.Tab
                              tab="dorm"
                              {...tabs}
                              disabled={generalStudent.length !== 0}
                              style={{
                                opacity: generalStudent.length !== 0 && "0.4",
                              }}
                            >
                              <TabHeader title={"Dorm"} />
                            </Tabs.Tab>
                            <Tabs.Tab tab="general" {...tabs}>
                              <TabHeader title={"General"} />
                            </Tabs.Tab>
                            <Tabs.Tab
                              tab="gender"
                              {...tabs}
                              disabled={generalStudent.length !== 0}
                              style={{
                                opacity: generalStudent.length !== 0 && "0.4",
                              }}
                            >
                              <TabHeader title={"Gender"} />
                            </Tabs.Tab>
                            <Tabs.Tab
                              tab="grade"
                              {...tabs}
                              disabled={generalStudent.length !== 0}
                              style={{
                                opacity: generalStudent.length !== 0 && "0.4",
                              }}
                            >
                              <TabHeader title={"Grade"} />
                            </Tabs.Tab>

                            {/*<Tabs.Tab tab="location" {...tabs}>Location</Tabs.Tab>*/}
                            {/*<Tabs.Tab tab="type" {...tabs}>Type</Tabs.Tab>*/}
                          </Tabs>
                        </TabList>
                        <Tabs.Panel tab="general" {...tabs}>
                          <Flex flexWrap={"wrap"} flexDirection={"column"}>
                            <Box width={1} pt={3}>
                              <Flex
                                onClick={() =>
                                  handleSelectGeneral("generalStudent", "All")
                                }
                              >
                                <Box>
                                  <Text {...textProps} name="all">
                                    All
                                  </Text>
                                </Box>
                                <Box ml={"auto"} />
                                <Box pr={2}>
                                  {generalStudent === "All" && (
                                    <Image src={check} />
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                            <Box width={1}>
                              <Divider />
                            </Box>
                            <Flex
                              onClick={() =>
                                handleSelectGeneral("generalStudent", "None")
                              }
                            >
                              <Box>
                                <Text {...textProps} name="none">
                                  None
                                </Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {generalStudent === "None" && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                          </Flex>
                        </Tabs.Panel>
                        <Tabs.Panel tab="gender" {...tabs}>
                          <Flex flexWrap={"wrap"} flexDirection={"column"}>
                            <Box width={1} pt={3}>
                              <Flex onClick={() => this.handleSelect("F", 0)}>
                                <Box>
                                  <Text {...textProps} name="male">
                                    Female
                                  </Text>
                                </Box>
                                <Box ml={"auto"} />
                                <Box pr={2}>
                                  {audience[0].includes("F") && (
                                    <Image src={check} />
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box width={1}>
                              <Divider />
                            </Box>

                            <Flex onClick={() => this.handleSelect("M", 0)}>
                              <Box>
                                <Text {...textProps} name="male">
                                  Male
                                </Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audience[0].includes("M") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                          </Flex>
                        </Tabs.Panel>
                        <Tabs.Panel tab="grade" {...tabs}>
                          <Flex flexWrap={"wrap"} flexDirection={"column"}>
                            <Flex
                              pt={3}
                              onClick={() => this.handleSelect("3", 1)}
                            >
                              <Box>
                                <Text {...textProps}>3rd Form</Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audience[1].includes("3") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                            <Flex onClick={() => this.handleSelect("4", 1)}>
                              <Box>
                                <Text {...textProps}>4th Form</Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audience[1].includes("4") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                            <Flex onClick={() => this.handleSelect("5", 1)}>
                              <Box>
                                <Text {...textProps}>5th Form</Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audience[1].includes("5") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                            <Flex onClick={() => this.handleSelect("6", 1)}>
                              <Box>
                                <Text {...textProps}>6th Form</Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audience[1].includes("6") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                          </Flex>
                        </Tabs.Panel>
                        <Tabs.Panel tab="dorm" {...tabs}>
                          <Flex
                            flexWrap={"wrap"}
                            flexDirection={"column"}
                            pt={3}
                          >
                            {dorms.map((dorm) => (
                              <Box width={1} key={dorm.id}>
                                <Flex
                                  onClick={() => this.handleSelect(dorm.id, 2)}
                                >
                                  <Box>
                                    <Text {...textProps}>{dorm.name}</Text>
                                  </Box>
                                  <Box ml={"auto"} />
                                  <Box pr={2}>
                                    {audience[2].includes(dorm.id) && (
                                      <Image src={check} />
                                    )}
                                  </Box>
                                </Flex>
                                <Box width={1}>
                                  <Divider />
                                </Box>
                              </Box>
                            ))}
                          </Flex>
                        </Tabs.Panel>
                      </Box>
                    )}
                  </Tabs.Container>
                </TabsContainer>
                <TabsContainer show={radioAudience === "faculty"}>
                  <Tabs.Container width={"100%"} margin={0} padding={0}>
                    {(tabs) => (
                      <Box>
                        <TabList>
                          <Tabs width={"100%"} margin={0} padding={0}>
                            <Tabs.Tab tab="general" {...tabs}>
                              <TabHeader title={"General"} />
                            </Tabs.Tab>
                            <Tabs.Tab
                              tab="gender"
                              {...tabs}
                              disabled={generalFaculty.length !== 0}
                              style={{
                                opacity: generalFaculty.length !== 0 && "0.4",
                              }}
                            >
                              <TabHeader title={"Gender"} />
                            </Tabs.Tab>
                          </Tabs>
                        </TabList>
                        <Tabs.Panel tab="general" {...tabs}>
                          <Flex flexWrap={"wrap"} flexDirection={"column"}>
                            <Box width={1} pt={3}>
                              <Flex
                                onClick={() =>
                                  handleSelectGeneral("generalFaculty", "All")
                                }
                              >
                                <Box>
                                  <Text {...textProps} name="all">
                                    All
                                  </Text>
                                </Box>
                                <Box ml={"auto"} />
                                <Box pr={2}>
                                  {generalFaculty === "All" && (
                                    <Image src={check} />
                                  )}
                                </Box>
                              </Flex>
                            </Box>
                            <Box width={1}>
                              <Divider />
                            </Box>
                            <Flex
                              onClick={() =>
                                handleSelectGeneral("generalFaculty", "None")
                              }
                            >
                              <Box>
                                <Text {...textProps} name="none">
                                  None
                                </Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {generalFaculty === "None" && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                          </Flex>
                        </Tabs.Panel>
                        <Tabs.Panel tab="gender" {...tabs}>
                          <Flex flexWrap={"wrap"} flexDirection={"column"}>
                            <Box width={1} pt={3}>
                              <Flex
                                onClick={() => handleAudienceFaculty("F", 0)}
                              >
                                <Box>
                                  <Text {...textProps} name="male">
                                    Female
                                  </Text>
                                </Box>
                                <Box ml={"auto"} />
                                <Box pr={2}>
                                  {audienceFaculty[0].includes("F") && (
                                    <Image src={check} />
                                  )}
                                </Box>
                              </Flex>
                            </Box>

                            <Box width={1}>
                              <Divider />
                            </Box>

                            <Flex onClick={() => handleAudienceFaculty("M", 0)}>
                              <Box>
                                <Text {...textProps} name="male">
                                  Male
                                </Text>
                              </Box>
                              <Box ml={"auto"} />
                              <Box pr={2}>
                                {audienceFaculty[0].includes("M") && (
                                  <Image src={check} />
                                )}
                              </Box>
                            </Flex>
                            <Divider />
                          </Flex>
                        </Tabs.Panel>
                      </Box>
                    )}
                  </Tabs.Container>
                </TabsContainer>
              </Flex>
            </FilterOverlay>
          </Block>
        )}
      </Overlay.Container>
    );
  }
}

Audience.propTypes = {
  editPost: PropTypes.bool,
};

Audience.defaultProps = {
  editPost: false,
};

export default Audience;
